<template>
    <o-table :title="$t('sandoz.contract_invoices')" ref="tableList" url="/api/sandoz/contract_invoices?include=contract&filter%5Bstatus%5D=pending" default-sort-by-direction="desc" default-sort-by="id"
      :enable-delete="false" :enable-new="false">
        <template slot="filter">
            <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                <o-filter-text :title="$t('sandoz.invoice_id')" column="id"></o-filter-text>
                <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id"></o-filter-text>
            </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="id">{{$t('sandoz.invoice_id')}}</o-table-header>
            <o-table-header column="id">{{$t('sandoz.contract_no')}}</o-table-header>
            <o-table-header column="id">{{$t('sandoz.contract_year')}}</o-table-header>
            <o-table-header column="id">{{$t('sandoz.start_month')}}</o-table-header>
            <o-table-header column="id">{{$t('sandoz.end_month')}}</o-table-header>
            <o-table-header column="already_invoiced_marketing_activities">{{$t('sandoz.already_invoiced_marketing_activities')}}</o-table-header>
            <o-table-header column="already_invoiced_services">{{$t('sandoz.already_invoiced_services')}}</o-table-header>
            <o-table-header column="created_at">{{$t('sandoz.created_at')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.contract.data.contract_no }}</td>
            <td>{{ props.item.contract.data.contract_year }}</td>
            <td>{{ props.item.start_month }}</td>
            <td>{{ props.item.end_month }}</td>
            <td>{{ props.item.already_invoiced_marketing_activities | formatInteger }}</td>
            <td>{{ props.item.already_invoiced_services | formatInteger }}</td>
            <td>{{ props.item.created_at | formatDate }}</td>
        </template>
        <template slot="body-controls" slot-scope="props">
            <td class="text-right">
                <b-btn class="mw-52" variant="primary" @click.prevent="downloadInvoice(props.item)">
                    <fa icon="download"/>
                </b-btn>
                <b-btn class="mw-52" variant="warning" @click.prevent="changeStatus(props.item)" :title="$t('customer.cancelled_invoice')">
                  <fa icon="times"/>
                </b-btn>
            </td>
        </template>
    </o-table>
</template>

<script>
  import {mapGetters} from 'vuex'
  import axios from 'axios'

  export default {
    data: () => ({
    }),
    created() {
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    methods: {
      downloadInvoice(invoice) {
        axios.get(`/api/sandoz/contract_invoices/${invoice.id}/pdf`, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(response.data,
              'sandoz_' + invoice.id + '.pdf', 'application/pdf'
            )
          })
      },
      changeStatus (invoice) {
        if(window.confirm('Are you sure want to cancel this invoice?')) {
          axios.post(`/api/sandoz/contract_invoices/status`, { id: invoice.id, status: 'cancelled' })
            .then((response) => {
              this.$notify({
                title: this.$i18n.t('core.saved'),
                text: this.$i18n.t('core.saved_text')
              })
              this.$refs.tableList.search()
            }).catch((error) => {
              this.$notify({
                text: this.$i18n.t('core.error_text', { error: error.response.data.message }),
                type: 'error'
              })
          })
        }
        return false
      }
    }
  }
</script>
